import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface RenewalManagerStoreState {
  quoteList: any[];
  totalQuotes: number;
  quoteHistory: any[];
  quoteNotes: any[];
}

export default {
  state: {
    quoteList: [],
    totalQuotes: 0,
    quoteHistory: [],
    quoteNotes: [],
  },
  mutations: {
    setQuoteList(state, payload) {
      // console.warn(payload , ' payload');
      state.quoteList = payload;
    },
    setTotalQuotes(state, payload) {
      state.totalQuotes = payload;
    },
    setQuoteHistory(state, payload) {
      //   console.warn(payload);
      state.quoteHistory = payload;
    },
    setQuoteNotes(state, payload) {
      //   console.warn(payload);
      state.quoteNotes = payload;
    },
  },
  actions: {
    async fetchquoteList(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/quote-list-renewal-mgr';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    async getQuoteHistory(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `quote/quote-activity-log?equoteid=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    async getQuoteNotes(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `quote/get-quote-notes?equoteid=${payload}`;
      return ApiServiceWrapper.get(endpoint);
    },
    async updatequoteListForProgramManaged(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-quote-programmanaged';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    async updatequoteListForResellerManaged(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/update-quote-resellerManaged';
      return ApiServiceWrapper.put(endpoint, payload);
    },
    async addQuoteNote(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'quote/add-equote-note';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    async renewalManagerExport(context: ActionContext<RenewalManagerStoreState, RootStoreState>, payload: any) { // tslint:disable-line
      const endpoint = 'quote/quote-list-renewal-mgr-export';
      return ApiServiceWrapper.post(endpoint, payload);
    },
  },
  getters: {
    getQuoteList(state) {
      return state.quoteList;
    },
    getTotalQuotes(state) {
      return state.totalQuotes;
    },
    getQuoteHistory(state) {
      return state.quoteHistory;
    },
    getQuoteNotes(state) {
      return state.quoteNotes;
    },
  },
  namespaced: true,
}as Module<RenewalManagerStoreState, RootStoreState>;
